const { wlGlobalConfig } = window;
export const ENV = wlGlobalConfig.__environment;
export const SITE_URL = wlGlobalConfig.__site_url;
export const AJAX_URL =
  ENV === 'development' || ENV === 'review'
    ? `${SITE_URL}/wp/wp-admin/admin-ajax.php?action=`
    : `${SITE_URL}/wp-admin/admin-ajax.php?action=`;
export const UPLOADS_URL = wlGlobalConfig.__uploads_url;
